import React from 'react';

type Props = {
  percentage: number;
};

export default function ProgressBar({ percentage = 50 }: Props) {
  return (
    <div className="h-2.5 w-full rounded-full bg-[#E4E4E4]">
      <div
        className="h-2.5 rounded-full bg-[#FF6600]"
        style={{ width: `${percentage}%` }}
      />
    </div>
  );
}
